import { useEffect } from "react";
import { getPermission, viewItem } from "../../../../classes/functions";
import Modal from 'react-modal';

export default function ModalFeaturesOpen({modalFeaturesOpen, featurePermission, setModalFeaturesOpen, items, setFeature, feature, listFeatures, saveFeatures, view, customStylesFeatures, status}){
    const checkIfPermissionExistsOrIfComponentMustToHaveInsertedPermission = ((featurePermission && getPermission(featurePermission)) || !featurePermission);
    async function setItemFeatures(index, value) {
        let aux = [];
        
        feature.forEach((element, inx) => {
          if (inx === index) {
            element.valor = value;
          }
          aux.push(element)
        });
        
        setFeature(() => aux);
      }

    return (
        <Modal  
            isOpen={modalFeaturesOpen}
            onRequestClose={() => setModalFeaturesOpen(false)}
            style={customStylesFeatures}
            contentLabel="Características"
            ariaHideApp={false}
            keepMounted
        >
            <div className="body-modal">
            <div className="formDiv">
                <table>
                <thead>
                    <tr>
                    <th>#</th>
                    <th>Característica</th>
                    <th>Valor</th>
                    </tr>
                </thead>
                <tbody>
                    {feature && feature?.length > 0 && feature.map((item, index)=>{
                    return(
                        <tr key={index}>
                        <td>
                            {index+1}
                        </td>
                        <td data-label="Característica">{viewItem(listFeatures, item.chave)}</td>
                        {featurePermission && !getPermission(featurePermission) && <td data-label="Valor">{item.valor}</td>}
                        {checkIfPermissionExistsOrIfComponentMustToHaveInsertedPermission && <td data-label="Valor"><input type="text" placeholder={item.descricao} value={feature[index].valor} onChange={ (e) => setItemFeatures(index, e.target.value) } maxLength="30" disabled={view || (status && ['001'].indexOf(status) === -1) || (parseInt(localStorage.getItem("usuario") !== items?.solicitante) && !getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS"))}/></td>}
                        </tr>
                    )
                    })}
                </tbody>
                </table>
            </div>
            <div className="formDiv">
                <button type="button" className="buttonSubmit" onClick={saveFeatures}>Confirmar</button>
                <button type="button" className="buttonCancel" onClick={() => setModalFeaturesOpen(false)} disabled={view}>Fechar</button>
            </div>
            </div>
        </Modal>
    )
}